import request from '@/utils/request';
import {  CommonResponse, PagingResData, PagingReq, Fireware, ResCode, FirewareType } from './baseDefine';
/**
 * 请求Fireware共用的请求结构
 *
 * @export
 * @interface FirewareCommonReq
 * @extends {PagingReq}
 */
export interface FirewareCommonReq extends PagingReq {
    fireware: Fireware;
}
export interface GetFireware {
    code: ResCode;
    msg: string;
    data: GetFirewareRes;
}
export interface GetFirewareRes {
    firewares: GetFirewareResData;
}
export interface GetFirewareResData extends PagingResData {
    list: Fireware[]
}


export interface GetFirewareType {
    code: ResCode;
    msg: string;
    data: FirewareType[];
}

export interface GetFirewareCrc{
    code: ResCode;
    msg: string;
    data: string;
}
export function createFireware(req: FirewareCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/fireware/createFireware', req);
}

export function deleteFireware(req: FirewareCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/fireware/deleteFireware', req);
}

export function updateFireware(req: FirewareCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/fireware/updateFireware', req);
}

export function geFirewares(req: FirewareCommonReq): Promise<GetFireware> {
    return request.post<GetFireware>('/api/fireware/getFirewares', req);
}

export function geFirewareTypes(): Promise<GetFirewareType> {
    return request.post<GetFirewareType>('/api/fireware/getFirewareTypes', {});
}

export function geFirewareCrc(req: FirewareCommonReq): Promise<GetFirewareCrc> {
    return request.post<GetFirewareCrc>('/api/fireware/getFirewareCrc', req);
}